module.exports = __webpack_public_path__ + "img/matriz_3.134dfa97.png";